import React from 'react';
import { Card, Flex, Text } from '@chakra-ui/react';
import { MdLockOutline } from 'react-icons/md';
import PropTypes from 'prop-types';

/**
 * Shown instead of a record's content when the logged-in account may not see it
 * - for example a country-scoped user opening another country's record by URL.
 */
const AccessDeniedCard = ({ title, description }) => {
  return (
    <Card
      w="100%"
      boxShadow="14px 17px 40px 4px rgba(112, 144, 176, 0.08)"
      borderRadius="20px"
      paddingInline="40px"
      paddingBlock="60px"
    >
      <Flex direction="column" align="center" justify="center" gap="12px">
        <MdLockOutline size={48} color="#A3AED0" />
        <Text fontSize="xl" fontWeight="bold" textAlign="center">
          {title}
        </Text>
        <Text color="secondaryGray.600" textAlign="center">
          {description}
        </Text>
      </Flex>
    </Card>
  );
};

AccessDeniedCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

AccessDeniedCard.defaultProps = {
  title: 'Not available',
  description:
    'This record does not exist, or it belongs to a country your account does not have access to.',
};

export default AccessDeniedCard;
